import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginActions } from '../../../features/auth/screens/LoginProps';

interface AuthState {
  userName: string;
  status: string;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  userName: '',
  status: '',
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<LoginActions>) => {
      state.userName = action.payload.data.userName;
      state.status = action.payload.status;
      state.isAuthenticated = true;
    },
    clearUserDetails: (state) => {
      state.userName = '';
      state.status = '';
      state.isAuthenticated = false;
    },
  },
});

export const { setUserDetails, clearUserDetails } = authSlice.actions;
export default authSlice.reducer;